#Работает совместно с checkboxes.scss

$ = require 'jquery'

class Checkboxes
  constructor: ->
    # нужно применить стили ко всем чекбоксам + лэйблам сразу после чекбоксов
    $('input[type="checkbox"]').each (i, e) =>
      $el = $(e)
      @updateClass $el
      $label = @getLabel($el)
#      $el.next('label').addClass('checkbox-label')
      $label.addClass('checkbox-label')

      $el.change @onChange

  getLabel: ($el, prev = false) ->
    if prev
      return $el.prev('label')
    else
      return $el.next('label')

  updateClass: ($el) =>
    $label = @getLabel($el)
    checked = $el.prop('checked')
#    if $el.attr('id') == 'ctl00_generalContent_autobusFilter_cblTourTypeList_1'
#      console.log 'XXX', checked
    if checked
#      console.log $el, 'checked'
      $label.addClass('checked')
#      $el.next().addClass('checked')
    else
#      console.log $el, 'unchecked'
#      $el.next().removeClass('checked')
      $label.removeClass('checked')

  onChange: (event) =>
    @updateClass $(event.target)


module.exports = Checkboxes
